import React from "react";
import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router";
import ErrorFallback from "./ErrorFallback";

/**
 * errorElement for the router. Inside the admin and teacher areas it renders in the
 * layout's content slot, so a failing page keeps the sidebar and navigation.
 */
const RouteErrorBoundary: React.FC<{ fullScreen?: boolean }> = ({ fullScreen = false }) => {
  const error = useRouteError();
  const navigate = useNavigate();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return (
      <ErrorFallback
        title="Page not found"
        message="This page doesn't exist or has moved."
        actionLabel="Go back"
        onAction={() => navigate(-1)}
        fullScreen={fullScreen}
      />
    );
  }

  console.error("Route error:", error);
  return <ErrorFallback actionLabel="Go back" onAction={() => navigate(-1)} fullScreen={fullScreen} />;
};

export default RouteErrorBoundary;
